var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import fetch from 'node-fetch';
import requestIp from 'request-ip';
import { createHash } from 'crypto';
const cache = new Map();
function hashedValue(key) {
    const inChache = cache.get(key);
    if (inChache) {
        return inChache;
    }
    else {
        const hash = createHash('sha256').update(key).digest('hex');
        cache.set(key, hash);
        return hash;
    }
}
function getUserData(req) {
    // Only create hash once
    const country = hashedValue(req.header('x-geoip-country') || '');
    return {
        client_ip_address: req.header('true-client-ip') || requestIp.getClientIp(req),
        client_user_agent: req.headers['user-agent'],
        fbc: req.universalCookies.get('_fbc') || '',
        fbp: req.universalCookies.get('_fbp') || '',
        country
    };
}
function createTrackFacebookEvent({ pixelId, token }) {
    return function trackFacebookEvent(data, channelPixelId, channelToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`https://graph.facebook.com/v13.0/${channelPixelId || pixelId}/events?access_token=${channelToken || token}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: [data]
                })
            });
            return response;
        });
    };
}
export default function createFacebookTracker(config) {
    const trackFacebookEvent = createTrackFacebookEvent(config);
    const track = (event, data, request) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            const user_data = getUserData(request);
            const event_time = Math.floor(Date.now() / 1000) - 60 * 5; // subtract 5 minutes to account for time difference between server and client
            const useArticleNumberAsId = data.useArticleNumberAsId;
            const defaults = {
                user_data,
                event_time,
                action_source: 'website',
                event_source_url: data.location,
                event_id: data.eventId
            };
            switch (event) {
                case 'trackProduct':
                    const productData = data.props;
                    if (productData.action === 'add') {
                        return yield trackFacebookEvent(Object.assign(Object.assign({}, defaults), { event_name: 'AddToCart', custom_data: {
                                contents: [
                                    {
                                        id: useArticleNumberAsId
                                            ? productData.product.articleNumber
                                            : productData.product.id.toString(),
                                        quantity: productData.quantity,
                                        item_price: (_a = productData.product.price) === null || _a === void 0 ? void 0 : _a.incVat
                                    }
                                ],
                                content_name: productData.product.name,
                                content_type: 'product',
                                currency: data.currency,
                                value: (_b = productData.product.price) === null || _b === void 0 ? void 0 : _b.incVat
                            } }), data.pixelId, data.token);
                    }
                    else if (productData.action === 'view') {
                        return yield trackFacebookEvent(Object.assign(Object.assign({}, defaults), { event_name: 'ViewContent', custom_data: {
                                contents: [
                                    {
                                        id: useArticleNumberAsId
                                            ? productData.product.articleNumber
                                            : productData.product.id.toString(),
                                        quantity: productData.quantity,
                                        item_price: (_c = productData.product.price) === null || _c === void 0 ? void 0 : _c.incVat
                                    }
                                ],
                                content_name: productData.product.name,
                                content_type: 'product',
                                currency: data.currency,
                                value: (_d = productData.product.price) === null || _d === void 0 ? void 0 : _d.incVat
                            } }), data.pixelId, data.token);
                    }
                    break;
                case 'trackAddToWishList':
                    const wishListData = data.props;
                    return yield trackFacebookEvent(Object.assign(Object.assign({}, defaults), { event_name: 'AddToWishlist', custom_data: {
                            content_name: wishListData.productName,
                            content_category: data.context.list || '',
                            content_ids: [wishListData.articleNumber],
                            currency: data.currency
                        } }), data.pixelId, data.token);
                case 'trackRegister':
                    return yield trackFacebookEvent(Object.assign(Object.assign({}, defaults), { event_name: 'CompleteRegistration', custom_data: {} }), data.pixelId, data.token);
                case 'trackCartCheckout':
                    const checkoutData = data.props;
                    return yield trackFacebookEvent(Object.assign(Object.assign({}, defaults), { event_name: 'InitiateCheckout', custom_data: {
                            content_ids: checkoutData.cart.items.map((item) => useArticleNumberAsId ? item.articleNumber : item.id.toString()),
                            contents: checkoutData.cart.items.map((item) => {
                                var _a;
                                return {
                                    id: useArticleNumberAsId
                                        ? item.articleNumber
                                        : item.id.toString(),
                                    quantity: item.quantity,
                                    item_price: (_a = item.product.price) === null || _a === void 0 ? void 0 : _a.incVat
                                };
                            }),
                            currency: data.currency,
                            num_items: checkoutData.cart.totalQuantity,
                            value: checkoutData.cart.productTotal.incVat
                        } }), data.pixelId, data.token);
                case 'trackPageView':
                    const pageViewData = data.props;
                    return yield trackFacebookEvent(Object.assign(Object.assign({}, defaults), { event_name: 'PageView', custom_data: {
                            content_name: pageViewData.title,
                            currency: data.currency
                        } }), data.pixelId, data.token);
            }
        }
        catch (error) {
            console.log(error);
            return error;
        }
    });
    return track;
}
//# sourceMappingURL=facebook.js.map